import { render } from "./CreateTeams.vue?vue&type=template&id=276a3df1"
import script from "./CreateTeams.vue?vue&type=script&lang=js"
export * from "./CreateTeams.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__